import { on } from 'delegated-events'
import { ResponsiveAccordionTabs } from 'foundation-sites/dist/js/foundation.esm.js'

const SELECTORS = Selectors({
  history: 'booking-history-container'
})

const $history = document.querySelector(SELECTORS.asClass('history'))

const fn = {
  init: () => {
    if ($history) {
      on('submit', '.booking-history-item__cancel', (e) => {
        if (confirm('Are you sure you want to cancel this request?')) {
          return true
        } else {
          e.preventDefault()

          return false
        }
      })

      fn.setupHistoryPanel()
    }
  },

  setupHistoryPanel: () => {
    const $tabs = document.querySelector('.booking-history-tabs')

    if ($tabs) {
      new ResponsiveAccordionTabs($tabs)
    }
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingaccountpage'),
  run: fn.init
}
